import * as Yup from 'yup'
import { validators } from 'Utility/validatorForm'
import { luhnCheck } from 'Utility/globalMethods'

export const processingRulesSchema = (intl) => ({
  ruleName: Yup.string()
    .test(
      'ruleName',
      intl.formatMessage({
        id: 't.app.paybylink.request.amount',
        defaultMessage: 'Max length 255 characters!'
      }),
      (value) => validators.maxLength(value, 255)
    )
    .required(
      intl.formatMessage({
        id: 't.app.settings.processingRules.form.isRequiredError',
        defaultMessage: 'Field is Required'
      })
    ),
  processingRulesType: Yup.string().required(
    intl.formatMessage({
      id: 't.app.settings.processingRules.form.isRequiredError',
      defaultMessage: 'Field is Required'
    })
  ),
  processingRulesStatus: Yup.string().required(
    intl.formatMessage({
      id: 't.app.settings.processingRules.form.isRequiredError',
      defaultMessage: 'Field is Required'
    })
  ),

  value: Yup.string()
    .when('processingRulesType', {
      is: (type) => type === 'CARD_BIN_BLOCK',
      then: Yup.string()
        .test(
          'isBin',
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isBinError',
            defaultMessage: 'The Number shall be between 6 and 8 digits'
          }),
          (value) => (value?.length > 0 ? /^\d{6,8}$/i.test(value) : true)
        )
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })
    .when('processingRulesType', {
      is: (type) => type === 'SINGLE_PAN_BLOCK',
      then: Yup.string()
        .test(
          'isPan',
          intl.formatMessage({
            id: 't.app.moto.request.validator.validPan',
            defaultMessage: 'Enter a valid PAN'
          }),
          (value) => (value ? /^\d{13,19}$/.test(value) : true) && luhnCheck(value)
        )
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })
    .when('processingRulesType', {
      is: (type) => type === 'MASKED_PAN',
      then: Yup.string()
        .test(
          'isMaskedPan',
          intl.formatMessage({
            id: 't.app.moto.request.validator.validPan',
            defaultMessage: 'Enter a valid PAN'
          }),
          (value) => {
            if (validators.isRequired(value)) {
              const isAmex = value.startsWith('34') || value.startsWith('37')
              return isAmex ? validators.isMaskedAmexPan(value) : validators.isMaskedAllPan(value)
            }
            return true
          }
        )
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })
    .when('processingRulesType', {
      is: (type) => type === 'CARD_TYPE',
      then: Yup.string().required(
        intl.formatMessage({
          id: 't.app.settings.processingRules.form.isRequiredError',
          defaultMessage: 'Field is Required'
        })
      ),
      otherwise: Yup.string().notRequired()
    })
    .when('processingRulesType', {
      is: (type) => type === 'IP_BLOCK',
      then: Yup.string()
        .test(
          'isIpAddress',
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isIpAddressError',
            defaultMessage: 'IP address is not correct'
          }),
          (value) => (validators.isRequired(value) ? validators.isIpAddress(value) : true)
        )
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })
    .when('processingRulesType', {
      is: (type) => type === 'CARDHOLDER_BLOCK',
      then: Yup.string()
        .test(
          'minLength',
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.minLength',
            defaultMessage: 'Min length 3 characters!'
          }),
          (value) => (value ? value.length >= 3 : true)
        )
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })

    .when('processingRulesType', {
      is: (type) => type === 'SETTING_AUTO_LOCKOUT_TIMES',
      then: Yup.string()
        .test('isTimeHHMMSS', ' ', (value) => validators.isTimeHHMMSS(value))
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })
    .when('processingRulesType', {
      is: (type) => type === 'SETTING_DUPLICATE_LOCKOUT_TIMES',
      then: Yup.string()
        .test('isTimeHHMMSS', ' ', (value) => validators.isTimeHHMMSS(value))
        .required(
          intl.formatMessage({
            id: 't.app.settings.processingRules.form.isRequiredError',
            defaultMessage: 'Field is Required'
          })
        ),
      otherwise: Yup.string().notRequired()
    })
})
